<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.5"
      d="M15.575 3.882v18.122M17.651 5.448l-1.92 1.903M17.529 20.528l-1.903-1.92M23.333 17.514l-7.707-4.448M22.967 15.067l-2.591.695M21.05 18.387l-.675-2.625M23.33 8.432l-7.751 4.475M20.99 7.584l-.668 2.58M22.936 10.852l-2.615-.688M8.767 9.7a4.695 4.695 0 0 0 0 6.639c.893.894 2.5 1.305 3.671 1.327V8.337a4.684 4.684 0 0 0-3.671 1.362ZM5.88 6.4l1.185 1.105M5.88 19.791l1.105-1.184M2.74 13.01l1.633-.03M12.381 22.028v-1.56M12.467 3.884V5.49"
    />
  </svg>
</template>
